import { render, staticRenderFns } from "./TitleFormats.vue?vue&type=template&id=399eb864&"
import script from "./TitleFormats.vue?vue&type=script&lang=js&"
export * from "./TitleFormats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports